import React from "react";
import { setTitle } from "../../../helpers/MetaTag";

import UploadCoverPhoto from "../../../components/sections/front/User/UploadCoverPhoto";

const UploadCoverPhotoPage = () => {
  setTitle("Memory Doddle | Upload Cover");
  return (
    <div className="mb-10">
      <UploadCoverPhoto />
    </div>
  );
};

export default UploadCoverPhotoPage;
